<template>
    <section>

        <div class="card border-0">
            <div class="card-body">

                <AddTeamMember :key="formSalesKey" :member="member" :editingIndex="editingIndex" @newForm="formSalesKey++;save()" />

                <div class="row pt-2 mx-1" v-for="(teamMember, index) in teamMembers">
                            <th class="col-md-2">{{ teamMember.first_name }}</th>
                            <th class="col-md-3">{{ teamMember.last_name }}</th>
                            <th class="col-md-4">{{ teamMember.email }}</th>
                            <th class="col-md-2 text-primary">
                                <a :href="teamMember.linkedin" target="_blank">Linkedin</a>
                                
                            </th>
                            <th class="col-md-1">
                                <button class="btn px-0 rounded-circle cursor-pointer btn-sm btn-muted"
                                    @click="deleteMember(index)" type="button">
                                    <i class="icon-trash"></i>
                                </button>
                                <button class="btn pr-0 rounded-circle cursor-pointer btn-sm btn-muted"
                                    @click="editMember(index)" type="button">
                                    <i class="icon-pencil"></i>
                                </button>
                            </th>
                        </div>

            </div>
        </div>
        <div>

        </div>
    </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import AddTeamMember from "@/components/Onboarding/AddTeamMember.vue";


export default {
    data() {
        return {
            member: {
                first_name: "",
                last_name: "",
                email: "",
                linkedin: ""
            },
            index: 0,
            editingIndex: 0,
            formSalesKey: 0
        }
    },

    computed: {
        ...mapState({
            teamMembers: state => state.onboarding.step3.teamMembers
        })
    },

    components: {
        AddTeamMember
    },

    methods: {
        ...mapActions("onboarding", {
            deleteTeamMember: "deleteTeamMember"
        }),
        save(){
            this.$emit("save");
        },
        deleteMember(index) {
            this.deleteTeamMember(index);
            this.$emit("save");
        },

        editMember(index) {
            this.editingIndex = index;
            this.member = this.teamMembers[index];
            this.deleteMember(index)
        }
    }
}
</script>